// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","container":"container--31PCw","formItemCol":"formItemCol--3IVjS","labelInfo":"labelInfo--1625_"};